import * as React from "react";
import styled, { css } from "styled-components";
import Separator from "../../Separator/index";
import mq from "../../utils/mediaQuery/index";
import defaultTheme from "../../defaultTheme";
export var StyledNavigationListSeparator = styled.div.withConfig({
  displayName: "NavigationListSeparator__StyledNavigationListSeparator",
  componentId: "sc-35jpk7-0"
})(["padding:0 ", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.spaceMedium;
}, mq.largeMobile(css(["padding:0 ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.spaceXLarge;
})));
StyledNavigationListSeparator.defaultProps = {
  theme: defaultTheme
};

var NavigationListSeparator = function NavigationListSeparator() {
  return React.createElement(StyledNavigationListSeparator, null, React.createElement(Separator, {
    spaceAfter: "none"
  }));
};

export default NavigationListSeparator;